import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtmFromUrl } from "../lib/utm";

/** Re-runs UTM capture on every route change. Mounted once near the router root. */
export default function UtmCapture() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    captureUtmFromUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);
  return null;
}
